import React from 'react';
import Fade from 'react-reveal/Fade';
import { useNavigate } from 'react-router-dom';
import Button from '../Form/Button';

const Banner = () => {
    const navigate = useNavigate();

    return (
        <section className="max-w-screen-xl py-20 mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 py-12">
                <Fade left>
                    <div className="order-1 flex flex-col justify-center h-full space-y-6">
                        <div className="flex flex-col space-y-4">
                            <img className="w-24" src="../../../assets/banner/medal.png" alt="Médaille" />
                            <h1 className="poppins text-gray-700 font-semibold text-3xl lg:text-4xl leading-relaxed">
                                La Meilleure Qualité <br />
                                <span className="text-5xl text-paragaia">de Produits en 2025</span>
                            </h1>
                            <p className="text-gray-500 text-light text-sm">
                                Nos produits sont parmi les meilleurs au monde.<br />
                                Bienvenue dans notre boutique.
                            </p>
                        </div>
                        <Button
                            className="w-48 mt-6 bg-paragaia text-white py-3 rounded-lg hover:bg-paragaiaLight transition poppins"
                            text="Découvrir nos produits"
                            onClick={() => navigate('/products')}
                        />
                    </div>
                </Fade>

                <Fade right>
                    <div className="order-2 flex justify-center items-center">
                        <div className="overflow-hidden rounded-3xl shadow-2xl">
                            <img
                                src="../../../assets/banner/banner.jpeg"
                                alt="Bannière"
                                className="object-cover w-full h-full transition-transform duration-500 hover:scale-105"
                            />
                        </div>
                    </div>
                </Fade>
            </div>
        </section>
    );
};

export default Banner;
